import * as React from "react";

import { StyledAlert, PaddedSurface as Surface } from "App/global-style";
import {
  TractorProductPriceFormValues,
  TractorTexts,
} from "../tractorInterface";

import { NumericInput } from "Components/Form/Input";
import { InputMode } from "Components/Form/Input/inputTypes";
import { VALUE_TYPE } from "Components/NumberValue";
import { TextLanguage } from "Store/texts/interfaces";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";

interface Props {
  readonly formProps: FormikProps<TractorProductPriceFormValues>;
  readonly updatePrices: (coverageAmount: number | undefined) => void;
  readonly texts: TractorTexts;
  readonly lang: TextLanguage;
}

export const FormElements = (props: Props): JSX.Element => {
  const { formProps, updatePrices, texts, lang } = props;
  const formTexts = texts.formText.checkPrice;

  return (
    <Surface>
      <NumericInput
        id="coverageAmount"
        name="coverageAmount"
        label={formTexts.coverageAmount.label[lang]}
        placeholder={formTexts.coverageAmount.placeholder?.[lang]}
        hint={formTexts.coverageAmount.hint?.[lang]}
        suffix={VALUE_TYPE.NOK}
        onChange={(values) => updatePrices(values.floatValue)}
        error={getError("coverageAmount", formProps)}
        inputMode={InputMode.NUMERIC}
        large
      />
      <StyledAlert
        title={texts.tile.productPrice.deductibleInfo.description[lang]}
        marginBottom="0px"
        fluid
      />
    </Surface>
  );
};
